<template>
  <div class="exam">
  	<el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item><a :href="'/tjkStudy/interview?groupId='+groupId+'&groupName='+groupName">{{ groupName }}的面试邀请</a></el-breadcrumb-item>
		  <el-breadcrumb-item>申请人详情</el-breadcrumb-item>
		</el-breadcrumb>
		<el-table :data="tjkList" border highlight-current-row style="width: 100%;margin-top: 20px;">
      <el-table-column prop="tjkName" label="淘金客" width="180" align="center"></el-table-column>
      <el-table-column prop="applyTime" label="申请日期" align="center"></el-table-column>
      <el-table-column prop="mobilePhone" label="电话号码" align="center"></el-table-column>
      <el-table-column prop="wechatNumber" label="微信号" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" align="center"></el-table-column>
      <el-table-column label="通过状态" align="center">
      	<template slot-scope="scope">
      		<span v-if="scope.row.passState == 'Passed'">已通过</span>
      		<span v-if="scope.row.passState == 'Failed'">未通过</span>
      	</template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span class="link-text" v-if="scope.row.passState == 'Passed'" @click="updateState(scope.row.applyId, 'Failed')">不通过</span>
          <span class="link-text" v-else-if="scope.row.passState == 'Failed'" @click="updateState(scope.row.applyId, 'Passed')">通过</span>
          <template v-else>
            <span class="link-text" @click="updateState(scope.row.applyId, 'Failed')">不通过</span>
            <span class="link-text" @click="updateState(scope.row.applyId, 'Passed')">通过</span>
          </template>
          <span class="link-text" @click="addRemark(scope.row.applyId, scope.row.remark)">备注</span>
          <span class="link-text" @click="queryTjkFun(scope.row.tjkId)">个人信息</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-if="tjkList.length > pageSize" :pages="pages" :pageNum="pageNum" @getData="getTjkList"></pagination>
    <template v-if="dialogVisibleTjk">
      <h3>淘金客个人信息</h3>
      <el-row :gutter="20">
        <el-col :span="6">平台昵称：{{ nick }}</el-col>
        <el-col :span="6">我的优势：{{ advantage }}</el-col>
        <el-col :span="6">平台外客服经验：{{ experience }}</el-col>
        <el-col :span="6">是否有小孩：{{ haveChildren }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">年龄：{{ age }}</el-col>
        <el-col :span="6">最低接受薪酬：{{ lowestSalary }}</el-col>
        <el-col :span="6">绑定微信：{{ wechatId }}</el-col>
        <el-col :span="6">每天可工作时长：{{ workHours }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">推荐人：无</el-col>
        <el-col :span="6">注册来源：{{ channel }}</el-col>
        <el-col :span="6">
          <p>
            <span>擅长语种：</span>
            <span v-for="(item,index) in language">
              {{item}}<span v-if="index < language.length-1"> 、</span>
            </span>
          </p>
        </el-col>
        <el-col :span="6">
          <p>
            <span>平台外经验工作类型：</span>
            <span v-for="(item,index) in experienceWork">
              {{item}}<span v-if="index < experienceWork.length-1"> 、</span>
            </span>
          </p>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">注册日期：{{ registerTime }}</el-col>
        <el-col :span="6">
          客服标签：
          <span v-if="providerTag == 'HH'">合伙人</span>
          <span v-else-if="providerTag == 'ZJ'">自建职场</span>
          <span v-else-if="providerTag == 'LY'">联营</span>
          <span v-else>平台客服</span>
        </el-col>
        <el-col :span="6">
          <p>
            <span>期望工作类型：</span>
            <span v-for="(item,index) in expectedWork">
              {{item}}<span v-if="index < expectedWork.length-1"> 、</span>
            </span>
          </p>
        </el-col>
        <el-col :span="6">所属团队：{{ providerName }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">最高学历：{{ education }}</el-col>
        <el-col :span="6">
          <p>
            <span>擅长行业：</span>
            <span v-for="(item,index) in industryed">
              {{item}}<span v-if="index < industryed.length-1"> 、</span>
            </span>
          </p>
        </el-col>
        <el-col :span="6">特殊任务要求：{{ acceptShortProject }}</el-col>
      </el-row>
    </template>
    <!--备注-->
    <el-dialog title="备注" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form :model="modal" ref="modal" :rules="rules" label-width="120px">
        <el-form-item label="备注" prop="description">
          <el-input type="textarea" autosize v-model="modal.remark" placeholder="请控制在100个字内" style="width: 300px;" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="addRemarkFun">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisibleTjk: false,
      groupId: this.$route.params.groupId, 
      groupName: this.$route.params.groupName, 
      interviewInviteId: this.$route.params.id,
      pageNum: 1,
      pageSize: 10,
      pages: 1,
      tjkId: '',
      tjkList: [],
      modal: {
        applyId: '',
        remark: ''
      },
      nick: '', //昵称
      age: '', //年龄
      wechatId: '', //绑定微信
      registerTime: '', //注册日期
      providerTag: '', //客服标签
      providerName: '', //所属团队
      advantage: '', //我的优势
      channel: '', //注册来源
      expectedWork: [], //期望工作类型
      acceptShortProject: '', //特殊任务要求
      haveChildren: '', //是否有小孩
      lowestSalary: '', //最低接受薪酬
      workHours: '', //每天可工作时长
      experience: '', //平台外客服经验
      experienceWork: [], //平台外经验工作类型
      industryed: [], //擅长行业
      language: [], //擅长语种
      education: '', //学历
      rules: {
        remark: [
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function() {
    this.getTjkList(1)
  },
  methods: {
    //查询面试申请人信息
    getTjkList(num) {
      var data = {
        'interviewInviteId': this.interviewInviteId,
        'tjkId': this.tjkId,
        'pageNum': num,
        'pageSize': this.pageSize
      }
      this.$http.post(API_ROOT.college + '/interview/applyRecord', data).then(response => {
        var result = response.data
        if(result.success) {
          this.pageNum = result.data.pageNum
          this.pages = result.data.pages
          this.tjkList = result.data.list
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //弹出层关闭-新增
    handleClose() {
      this.$refs['modal'].resetFields()
      this.dialogVisible = false
    },
    addRemark(applyId, remark) {
      this.modal.applyId = applyId
      this.modal.remark = remark
      this.dialogVisible = true
    },
    addRemarkFun() {
      var self = this
      this.$refs.modal.validate((valid) => {
        if(valid) {
          self.$http.post(API_ROOT.college + '/interview/remark', self.modal).then(response => {
            var result = response.data
            if(result.success) {
              self.$message({
                message: '操作成功',
                type: 'success',
                center: true,
                duration: 1000
              })
              self.handleClose()
              self.getTjkList(this.pageNum)
            }else {
              self.$alert(result.msg)
            }
          }, response => {
            self.$alert('网络繁忙，请稍后重试！')
          })
        }else {
          return false
        }
      })
    },
    //通过/不通过
    updateState(applyId, passState) {
      var data = {
        'applyId': applyId,
        'passState': passState
      }
      this.$http.post(API_ROOT.college + '/interview/evaluation', data).then(response => {
        var result = response.data
        if(result.success) {
          this.$message({
            message: '已修改',
            type: 'success',
            center: true,
            duration: 1000
          })
          this.getTjkList(this.pageNum)
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //查询淘金客个人信息
    queryTjkFun(tjkId) {
      this.queryTjk(tjkId)
      this.queryTjkTypes(tjkId)
      this.dialogVisibleTjk = true
    },
    //查询个人信息
    queryTjk(tjkId) {
      this.$http.post(API_ROOT.tjk + '/manageInfo/getTjkDatabase', {'tjkId': tjkId}).then(response => {
        var result = response.data
        if(result.success) {
          this.nick = result.data.tjkUserExt.nick
          this.age = result.data.tjkUserExt.age
          this.wechatId = result.data.tjkUserExt.wechatId
          this.registerTime = result.data.tjkUserExt.registerTime
          this.providerTag = result.data.providerTag
          this.providerName = result.data.providerName
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //查询个人信息
    queryTjkTypes(tjkId) {
      this.expectedWork = []
      this.experienceWork = []
      this.industryed = []
      this.language = []
      this.$http.post(API_ROOT.tjkuser + '/personalInfo/getManagePersonTypes', {'tjkId': tjkId}).then(response => {
        var result = response.data
        if(result.success) {
          for(var i = 0 ; i < result.data.length ; i++) {
            if(result.data[i].typeName == '我的优势') {
              this.advantage = result.data[i].typeValue
            }
            if(result.data[i].typeName == '从何知晓淘金渠道') {
              for(var j = 0 ; j < result.data[i].childrenList.length ; j++) {
                if(result.data[i].childrenList[j].checked == 'Yes') {
                  this.channel = result.data[i].childrenList[j].typeName
                }
              }
            }
            if(result.data[i].typeName == '是否有小孩') {
              this.haveChildrenList =result.data[i].childrenList
              for(var j = 0 ; j < result.data[i].childrenList.length ; j++) {
                if(result.data[i].childrenList[j].checked == 'Yes') {
                  this.haveChildren = result.data[i].childrenList[j].typeName
                }
              }
            }
            if(result.data[i].typeName == '期望工作类型') {
              for(var j = 0 ; j < result.data[i].childrenList.length ; j++) {
                if(result.data[i].childrenList[j].checked == 'Yes') {
                  this.expectedWork.push(result.data[i].childrenList[j].typeName)
                }
              }
            }
            if(result.data[i].typeName == '是否接收短期项目') {
              for(var j = 0 ; j < result.data[i].childrenList.length ; j++) {
                if(result.data[i].childrenList[j].checked == 'Yes') {
                  this.acceptShortProject = result.data[i].childrenList[j].typeName
                }
              }
            }
            if(result.data[i].typeName == '最低可接收薪酬') {
              for(var j = 0 ; j < result.data[i].childrenList.length ; j++) {
                if(result.data[i].childrenList[j].checked == 'Yes') {
                  this.lowestSalary = result.data[i].childrenList[j].typeName
                }
              }
            }
            if(result.data[i].typeName == '每天可用于平台的工作时长') {
              for(var j = 0 ; j < result.data[i].childrenList.length ; j++) {
                if(result.data[i].childrenList[j].checked == 'Yes') {
                  this.workHours = result.data[i].childrenList[j].typeName
                }
              }
            }
            if(result.data[i].typeName == '平台外经验') {
              if(result.data[i].childrenList[0].typeName == '平台外客服经验') {
                for(var j = 0 ; j < result.data[i].childrenList[0].childrenList.length ; j++) {
                  if(result.data[i].childrenList[0].childrenList[j].checked == 'Yes') {
                    this.experience = result.data[i].childrenList[0].childrenList[j].typeName
                  }
                }
              }
              if(result.data[i].childrenList[1].typeName == '平台外经验工作类型') {
                for(var j = 0 ; j < result.data[i].childrenList[1].childrenList.length ; j++) {
                  if(result.data[i].childrenList[1].childrenList[j].checked == 'Yes') {
                    this.experienceWork.push(result.data[i].childrenList[1].childrenList[j].typeName)
                  }
                }
              }
              if(result.data[i].childrenList[2].typeName == '行业') {
                for(var j = 0 ; j < result.data[i].childrenList[2].childrenList.length ; j++) {
                  if(result.data[i].childrenList[2].childrenList[j].checked == 'Yes') {
                    this.industryed.push(result.data[i].childrenList[2].childrenList[j].typeName)
                  }
                }
              }
            }
            if(result.data[i].typeName == '擅长语种') {
              for(var j = 0 ; j < result.data[i].childrenList.length ; j++) {
                if(result.data[i].childrenList[j].checked == 'Yes') {
                  this.language.push(result.data[i].childrenList[j].typeName)
                }
              }
            }
            if(result.data[i].typeName == '学历') {
              for(var j = 0 ; j < result.data[i].childrenList.length ; j++) {
                if(result.data[i].childrenList[j].checked == 'Yes') {
                  this.education = result.data[i].childrenList[j].typeName
                }
              }
            }
          }
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.link-text {
  display: inline-block;
  margin: 5px;
  cursor: pointer;
  color: #409eff;
}
h3 {
  padding-top: 20px;
  padding-bottom: 10px;
}
.el-row {
  line-height: 36px;
}
</style>


// WEBPACK FOOTER //
// ./src/page/college/interviewTjk.vue